module.exports = __webpack_public_path__ + "img/7.ff2f9ab1.png";